import { forwardRef, useEffect, useState } from "react";
import { classNames, useMemoizedFunction } from "zeta-dom-react";
import { Mixin, useScrollableMixin } from "brew-js-react";
import { useAnimatedIndicator } from "src/util/cssUtil";
import { ToggleButtonGroup, ToggleButtonGroupProps } from ".";
import { setTimeoutOnce } from "zeta-dom/util";

export const Tab = forwardRef<HTMLDivElement, ToggleButtonGroupProps>((props, ref) => {
    const scrollable = useScrollableMixin({ direction: 'x-only' });
    const indicator = useAnimatedIndicator({ selector: 'button' });
    const [value, setValue] = useState(props.value);

    const updateIndicator = useMemoizedFunction(() => {
        const activeElement = scrollable.elements()[0]?.querySelector('button.active');
        if (activeElement) {
            setTimeout(() => {
                scrollable.scrollToElement(activeElement, 'center', 'center', 200);
            });
        }
        indicator.setActiveIndex(props.items.findIndex(v => v.value === value));
    });

    useEffect(() => {
        setTimeout(() => {
            scrollable.setOptions({
                getContentDimension($elm) {
                    let lastChild = $elm.find('button:last-of-type')[0];
                    return { width: lastChild ? lastChild.getBoundingClientRect().right - lastChild.parentElement!.getBoundingClientRect().left : 0, height: 0 };
                }
            });
        });
    }, [scrollable]);

    useEffect(() => {
        setTimeoutOnce(updateIndicator);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.items, value]);

    useEffect(() => {
        if (props.value !== undefined && props.value !== value) {
            setValue(props.value);
        }
    }, [props.value, value]);

    return (
        <div {...Mixin.use(ref, scrollable, classNames(props.className, 'eac-tab'))}>
            <ToggleButtonGroup {...props} {...Mixin.use(indicator.ref, scrollable.target)} onChange={onChange} />
        </div>
    );

    function onChange(value1: string, index: number) {
        setValue(value1);
        return props.onChange?.(value1, index);
    }
});
